import React from "react"
import css from "./Radio.scss"
import { PropTypes } from "prop-types"
// TODO using className is not right implementation and must be avoided  , will need to remove
function Radio({ child, isSelected, isDisabled, onClick, className, name, centerAlign }) {
    const handleChange = () => {
        if (!isDisabled) {
            onClick && onClick()
        }
    }
    return (
        <div
            className={`flex ${className || ""} ${centerAlign ? "alignCenter" : ""}`}
            onClick={() => handleChange()}
        >
            <input
                className={`${css.radioInput} ${isDisabled ? css.disabledInput : ""} pointer`}
                type={"radio"}
                name={name}
                disabled={isDisabled}
                checked={isSelected}
                readOnly // This is because we have onClick on parent not on input
            />
            {child}
        </div>
    )
}

Radio.propTypes = {
    child: PropTypes.node,
    isSelected: PropTypes.bool,
    isDisabled: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string,
    name: PropTypes.string,
    centerAlign: PropTypes.bool,
}

Radio.defaultProps = {
    centerAlign: false,
}

export default Radio
